import createHelpCenterSlice, {
  initialState,
} from '@sv-support-sdk/store/src/modules/helpCenter/slices';

export const helpCenterSlice = createHelpCenterSlice({
  name: 'helpCenter',
  initialState: { ...initialState },
  reducers: {},
});

export const {
  setCategories,
  setTopics,
  updateTopic,
  voteTopic,
  setCategoriesLoading,
  setTopicsLoading,
  setTopicDetailsLoading,
} = helpCenterSlice.actions;

export default helpCenterSlice.reducer;
